import React from 'preact';

export default function Position() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20.01 20">
      <g id="Asset 1 9" clip-path="url(#clip0_250_32341)">
        <g id="Layer_1-2">
          <path id="Vector" d="M1.59558 18.3017V6.39014H0.742496C0.315956 6.39014 0 6.70609 0 7.13263V19.1469C0 19.5734 0.315956 19.9999 0.853081 19.9999H12.7646C13.1912 19.9999 13.6177 19.684 13.6177 19.1469V18.3017H1.59558Z" />
          <path id="Vector_2" d="M4.78674 15.1026V3.19897H3.93366C3.50712 3.19897 3.19116 3.51493 3.19116 3.94147V15.9557C3.19116 16.3822 3.50712 16.8088 4.04424 16.8088H15.9558C16.3823 16.8088 16.8089 16.4928 16.8089 15.9557V15.1026H4.78674Z" />
          <path id="Vector_3" d="M19.1469 0H7.13269C6.70615 0 6.3902 0.315956 6.3902 0.742496V12.7567C6.3902 13.1833 6.70615 13.6098 7.24328 13.6098H19.1548C19.5814 13.6098 20.0079 13.2938 20.0079 12.7567V0.742496C19.9052 0.315956 19.5814 0 19.1548 0H19.1469ZM18.3017 11.9115H7.98577V1.59558H18.3017V11.9115Z" />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_250_32341">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}